module.exports = __webpack_public_path__ + "img/EN.c5cdb172.svg";